import type Post from '@/models/post';

/**
 * Normalize text for user-created place title/address matching: trim, lowercase,
 * collapse internal whitespace. Used by save-overlay duplicate detection.
 */
export function normalizePlaceTextForFingerprint(s: string | undefined | null): string {
  return (s ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
}

/**
 * Extract deduped fingerprint keys from all postLocations in a Post.
 * Keys: "g:<googlePlaceId>", "m:<mongoLocationId>", "u:<normalizedTitle>|<normalizedAddress>"
 */
export function extractFingerprintKeysFromPost(post: Post): string[] {
  const seen = new Set<string>();
  for (const pl of post.postLocations ?? []) {
    const loc = pl.location;
    const googlePlaceId = (loc?.google_place_id ?? '').trim();
    if (googlePlaceId) seen.add(`g:${googlePlaceId}`);

    const mongoFromLocation = (loc?._id ?? '').trim();
    if (mongoFromLocation) seen.add(`m:${mongoFromLocation}`);
    const mongoFromPostLocation = (pl.location_id ?? '').trim();
    if (mongoFromPostLocation) seen.add(`m:${mongoFromPostLocation}`);

    const title = normalizePlaceTextForFingerprint(pl.name ?? pl.body ?? loc?.name);
    const address = normalizePlaceTextForFingerprint(
      pl.address ?? loc?.a3_intl_address ?? loc?.address
    );
    if (title) seen.add(`u:${title}|${address}`);
  }
  return Array.from(seen);
}
